import axios from "axios";

// const url = 'http://localhost:5000';
const url = process.env.REACT_APP_API_URL_DASHBOARD;

export default class DashboardService {

    getCount() {
        return axios.get(url + '/tr_oss_checklist_count')
    }

    getSertifikat() {
        return axios.get(url + '/tr_oss_checklist_terbit')
    }

    getVerify() {
        return axios.get(url + '/tr_oss_checklist_verify')
    }

    getSertifikasi() {
        return axios.get(url + '/tr_oss_checklist_raw')
    }

    // Jumlah SPT
    getSpt() {
        return axios.get(url + '/tr_pbumku_spt_cnt')
    }

    // Jumlah Per Provinsi
    getProvinsi() {
        return axios.get(url + '/tr_oss_checklist_propinsi')
    }

    // Jumlah UPI
    getUpi() {
        return axios.get(url + '/tt_dashboard_upi')
    }

    // Jumlah HACCP
    getSft() {
        return axios.get(url + '/tt_dashboard_sft')
    }

    // Jumlah SKHS
    getSkv() {
        return axios.get(url + '/tt_dashboard_skv')
    }

    // Jumlah UPI Baru
    getUpn() {
        return axios.get(url + '/tt_dashboard_upn')
    }

    // Jumlah frequensi
    getFrequensi(kdUpt, tglAwal, tglAkhir) {
        return axios.get(url + '/getfreq/' + kdUpt + '/' + tglAwal + '/' + tglAkhir)
    }

    // Jumlah frequensi negara
    getFrequensiNegara(kdUpt, tglAwal, tglAkhir) {
        return axios.get(url + '/gefreqctr/' + kdUpt + '/' + tglAwal + '/' + tglAkhir)
    }

    // Jumlah frequensi upt
    getFrequensiUpt(kdUpt, tglAwal, tglAkhir) {
        return axios.get(url + '/gefrequpt/' + kdUpt + '/' + tglAwal + '/' + tglAkhir)
    }

    // Jumlah frequensi upt
    getFrequensiTrader(kdUpt, tglAwal, tglAkhir) {
        return axios.get(url + '/gefreqtrd/' + kdUpt + '/' + tglAwal + '/' + tglAkhir)
    }

    // Jumlah Total Frequensi
    getJumlahFrequensi(kdUpt, tglAwal, tglAkhir) {
        return axios.get(url + '/getjumfreq/' + kdUpt + '/' + tglAwal + '/' + tglAkhir)
    }

    // Jumlah Total Volume
    getJumlahVolume(kdUpt, tglAwal, tglAkhir) {
        return axios.get(url + '/getjumvol/' + kdUpt + '/' + tglAwal + '/' + tglAkhir)
    }

    // Jumlah Nilai
    getJumlahNilai(kdUpt, tglAwal, tglAkhir) {
        return axios.get(url + '/getnilai/' + kdUpt + '/' + tglAwal + '/' + tglAkhir)
    }

    // Bulan Tahun
    getBulanTahun() {
        return axios.get(url + '/getbulantahun')
    }

    // Nama UPT
    getNamaUPT(kdUpt) {
        return axios.get(url + '/getuptbyid/' + kdUpt)
    }
}